import {GET_GROUP_SNAPSHOT_BY_ID, CLEAN_GROUP_SNAPSHOT} from '../actiontypes';
import {groupSnapshotUrl} from '../apiUrls';

export const getSnapshotById = (engagementId, snapshotId, componentId, setSnapshotId = null) => {
	const url = `${groupSnapshotUrl(engagementId, snapshotId, componentId, setSnapshotId)}`;
	return {
		type: GET_GROUP_SNAPSHOT_BY_ID,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const cleanGroupSnapshot = () => ({
	type: CLEAN_GROUP_SNAPSHOT
});
